<template>
  <div id="gymadd" v-if="validUser.hash" style="margin-top:0px;">

    <md-toolbar style="position:fixed; z-index:15; width:100%; top:0px; text-align:left;">

      <md-button @click="restorePosition(), clearRoute(), goBack()" class="md-icon-button">
        <md-icon>close</md-icon>
      </md-button>

      <!-- <router-link tag="md-button" class="md-icon-button" to="/Gymlist"
      @click.native="restorePosition(), clearRoute()">
        <md-icon style="color:#ffffff !important;">close</md-icon>
      </router-link> -->
        <h2 class="md-title">{{ pageTitle }}</h2>
    </md-toolbar>
    <div class="routepreview">
    <div class="imagetest">
      <l-map ref="leafAdd" style="height:220px;" :minZoom="minZoom" :maxZoom="maxZoom" :max-bounds="maxBounds" :options="mapOptions" :crs="crs">
         <l-image-overlay :url="urlGym" :bounds="bounds"></l-image-overlay>
        <l-marker :lat-lng.sync="marker" :draggable="draggable" @dragend="condition()" :icon="iconCross"></l-marker>
        <l-control-zoom position="bottomright">x</l-control-zoom>
      </l-map>
      <div class="switchLoc">
        <md-switch v-model="isLocated" @click.native="restorePosition()"></md-switch><br>
        <md-tooltip md-direction="left">{{ setLocation }}</md-tooltip>
      </div>
    </div>
    </div>
  <div id="addR" style="position:relative; top:275px;">

        <!-- <div style="margin-left:16px;">
          <p class="md-caption">
            <strong style="color:#00838f;">
              <span v-model="xCoord">Marker location: x = {{ xCoord }}</span>
              <span v-model="yCoord"> y = {{ yCoord }}</span>
            </strong>
         </p>
       </div> -->

    <form novalidate @submit.stop.prevent="">
      <md-list class="md-triple-line">
        <md-list-item>
          <md-input-container :class="errorClass">
            <label>Route neu</label>
            <md-input required v-model="newLog.routeName" @blur.native="checkRoute()"
                      style="font-size:18px !important; font-weight:400;"></md-input>
            <span v-if="newLog.routeName" class="md-error"></span>
            <span v-else class="md-error">Pflichtfeld</span>
          </md-input-container>
        </md-list-item>

        <md-list-item>
          <div class="md-list-container">
            <span class="md-caption">Schwierigkeit</span>
            <div style="margin-top:10px; margin-bottom:10px;">
              <md-button style="margin-left:-8px;" class="md-icon-button" @click="decrement(), setFrench()">
                <md-icon style="color:#00838f; font-size:32px;">remove_circle</md-icon>
              </md-button>
              <div style="text-align:center; padding-top:10px; display:inline-block; padding-left:10px; margin:auto; width:50px;"
                   class="md-title">{{ slideRange | gradeFilter }}</div>
              <md-button class="md-icon-button" @click="increment(), setFrench()">
                <md-icon style="color:#00838f; font-size:32px;">add_circle</md-icon>
              </md-button>
            </div>
            <md-divider style="margin-right:16px; margin-left:16px;"></md-divider>
          </div>
        </md-list-item>

        <md-list-item>
          <md-input-container>
            <label>Schwierigkeit (Französisch)</label>
            <md-textarea readonly disabled v-model="newLog.gradeFrench" style="font-weight:400;"></md-textarea>
          </md-input-container>
        </md-list-item>
      </md-list>

      <md-list style="position:relative;">

        <md-list-item style="max-width:300px; margin-bottom:5px;">
          <md-checkbox id="my-test1" name="my-test1" v-model="newLog.isLead">isLead</md-checkbox>
          <md-checkbox id="my-test1" name="my-test1" v-model="newLog.isToprope">isToprope</md-checkbox>
        </md-list-item>

      <md-divider style="margin-right:16px; margin-left:16px;"></md-divider>

      <md-list-item>
          <md-input-container>
          <label>Route geschraubt von</label>
          <md-input v-model="newLog.routeSetter"></md-input>
        </md-input-container>
      </md-list-item>

      <md-list-item>
        <div class="md-list-container" @click="openDialog('date3')" style="width:100%; cursor:pointer;">
          <div class="md-caption">geschraubt am</div>
          <div>{{ logDate | localdate }}</div>
          <md-divider style="margin-right:16px; margin-left:16px;"></md-divider>
        </div>
      </md-list-item></br>

      <md-list-item>
          <md-input-container>
          <label>Route entfernt von</label>
          <md-input v-model="newLog.routeRemovedBy"></md-input>
        </md-input-container>
      </md-list-item>

      <md-list-item>
        <div class="md-list-container" @click="openDialog('date4')" style="width:100%; cursor:pointer;">
          <div class="md-caption">entfernt am</div>
          <div v-if="!removeDate">{{ removeDate }}</div>
          <div v-else>{{ removeDate | localdate }}</div>
          <md-divider style="margin-right:16px; margin-left:16px;"></md-divider>
        </div>
      </md-list-item>

      <md-list-item></br>
        <div class="md-list-container" @click="openDialog('wall2')" style="width:100%; cursor:pointer;">
          <md-input-container>
            <label>Wandbereich</label>
            <md-input v-model="newLog.wallArea">{{ newLog.wallArea }}</md-input>
          </md-input-container>
        </div>
      </md-list-item>

      <md-list-item v-if="!resetting">
        <div class="md-list-container">
          <span class="md-caption">Charakter der Route</span>
            <table>
            <td>
              <md-checkbox md-value="strength" v-model="optionAttributes" class="md-primary">Kräftig</md-checkbox>
              <md-checkbox md-value="long reach" v-model="optionAttributes" class="md-primary">Längenzüge</md-checkbox>
            </td>
            <td>
              <md-checkbox md-value="pumped forearms" v-model="optionAttributes" class="md-primary">Pumpig</md-checkbox>
              <md-checkbox md-value="technical" v-model="optionAttributes" class="md-primary">Technisch</md-checkbox>
            </td>
          </table>
          <md-divider style="margin-right:16px; margin-left:16px;"></md-divider><br>
        </div>
      </md-list-item>

      <md-list-item style="padding-top:10px; padding-bottom:10px;">
        <md-icon v-if="newLog.color == 'mixed'" class="mixedColor"></md-icon>
        <md-icon v-else-if="newLog.color == 'white'" class="whiteColor"></md-icon>
        <md-icon v-else-if="!newLog.color" class="whiteColor"></md-icon>
        <md-icon v-else :class="newLog.color" v-bind:style="{ backgroundColor: newLog.color }"></md-icon>
        <div class="md-list-container" @click="openDialog('color2')" style="width:100%; cursor:pointer;">
          <div class="md-caption">Farbe</div>
          <div v-if="newLog.color">{{ newLog.color | colorText }}</div>
          <div v-else></div>
          <md-divider style="margin-right:16px; margin-left:16px;"></md-divider>
        </div>
      </md-list-item>

      <md-list-item>
        <md-input-container>
          <label>Hinweise zur Route</label>
          <md-input v-model="newLog.remarks"></md-input>
        </md-input-container>
      </md-list-item>

      <md-list-item>
        <md-input-container>
          <label>Interne Notizen (Staff only)</label>
          <md-input v-model="newLog.internalNote"></md-input>
        </md-input-container>
      </md-list-item>

      <md-list-item>
        <md-switch id="publish" name="publish" v-model="newLog.isPublished">Veröffentlicht</md-switch>
      </md-list-item>
    </md-list>

    <md-layout md-align="end">
        <md-button @click="verifyLocation()" class="md-raised md-accent" style="right:8px;">
          Speichern</md-button>
    </md-layout>
  </form>

  <md-dialog-confirm
    :md-title="newLog.routeName"
    :md-content-html="confirm.contentHtml"
    :md-ok-text="confirm.ok"
    :md-cancel-text="confirm.cancel"
    @open="onOpen"
    @close="onClose"
    ref="dialog6">
  </md-dialog-confirm>

  <md-dialog-alert
    :md-title="locationAlert.title"
    :md-content-html="locationAlert.contentHtml"
    @open="onOpen"
    @close="verifyName"
    ref="dialog7">
  </md-dialog-alert>

  <md-dialog-alert
    :md-title="nameAlert.title"
    :md-content-html="nameAlert.contentHtml"
    @open="onOpen"
    @close="onClose"
    ref="dialog8">
  </md-dialog-alert>

  <md-dialog md-open-from="#custom" md-close-to="#custom" ref="color2">

    <md-dialog-content style="padding:0px">
      <md-list class="md-dense">
        <md-list-item @click="setColor(colors.color)" v-for="colors in sectorColors" :key="colors.color">
          <md-icon v-if="colors.color == 'mixed'" class="mixedColor"></md-icon>
          <md-icon v-else-if="colors.color == 'white'" class="whiteColor"></md-icon>
          <md-icon v-else :class="colors.color" v-bind:style="{ backgroundColor: colors.color }"></md-icon>
          <span>{{ colors.name }}</span>
        </md-list-item>
      </md-list>
    </md-dialog-content>

  </md-dialog>

  <md-dialog md-open-from="#custom" md-close-to="#custom" ref="date3">
    <md-dialog-content style="padding:0px">
      <datepicker :inline="true" :format="format" :language="de" :monday-first="monday" v-model="logDate" @click="datePicked()" @selected="closeDialog('date3')"></datepicker>
    </md-dialog-content>
  </md-dialog>

  <md-dialog md-open-from="#custom" md-close-to="#custom" ref="date4">
    <md-dialog-content style="padding:0px">
      <datepicker :inline="true" :format="format" :language="de" :monday-first="monday" v-model="removeDate" @click="datePicked()" @selected="closeDialog('date4')"></datepicker>
    </md-dialog-content>
  </md-dialog>

  <md-dialog md-open-from="#custom" md-close-to="#custom" ref="wall2">
    <md-dialog-content style="padding:0px">
      <md-list>
        <md-list-item @click="setWand(gymWall)" v-for="(gymWall, index) in gymWalls" :key="index">
          <span>{{ gymWall }}</span>
        </md-list-item>
      </md-list>
    </md-dialog-content>
  </md-dialog>

  </div>
</div>

</template>

<script>
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

import Datepicker from 'vuejs-datepicker'
import {de, en} from 'vuejs-datepicker/dist/locale'

import { LMap, LImageOverlay, LMarker, LIcon, LControl, LControlZoom } from 'vue2-leaflet'

export default {
  name: 'gymadd',

  components: {
    Datepicker,
    LMap,
    LImageOverlay,
    LMarker,
    LIcon,
    LControl,
    LControlZoom
  },

  created () {
    if (!this.validUser.hash) {
      window.location.href = '/'
    } else {

    }
  },

  mounted () {
    this.$refs.leafAdd.mapObject.setView([220, 350], 0)
  },

  data () {
    return {
      mapOptions: { zoomControl: false, attributionControl: false },
      center: L.latLng(220, 350),
      draggable: true,
      bounds: [[0, 0], [220, 350]],
      maxBounds: [[20, 0], [200, 350]],
      minZoom: 0,
      maxZoom: 4,
      crs: L.CRS.Simple,
      marker: [110, 175],
      testmap: '../../../static/kioskMM.svg',
      iconCross: L.icon({
        iconUrl: 'static/icon-cross.svg',
        iconSize: [30, 30],
        iconAnchor: [15, 15],
      }),

      isLocated: false,
      resetting: false,
      newLog: {
        routeName: '',
        color: '',
        grade: '',
        gradeNo: 0,
        isLead: false,
        isToprope: false,
        userRating: 0,
        climbed: false,
        overview: [],
        routeSetter: '',
        routeRemovedBy: '',
        internalNote: '',
        gradeFrench: '',
        attributes: [],
        wallArea: '',
        dateCreated: new Date().getTime(),
        dateRemoved: '',
        isPublished: false,
        remarks: '',
        sortWeight: -1
      },

      options: ['strength', 'long reach', 'pumped forearms', 'technical'],
      optionAttributes: [],
      setLocation: 'Routenposition fixieren',
      coordOverview: [],

      format: 'dd.MM.yyyy',
      monday: true,
      de: de,

      userRating: '',

      logDate: new Date(),
      removeDate: '',

      pageTitle: 'Neue Route hinzufügen',
      wallAreas: [],
      linkSector: '',
      errorClass: '',
      locationAlert: {
        title: 'Routenposition setzen',
        contentHtml: 'Bitte setze den Routenmarker auf der Karte und schalte die Routenposition an.',
        ok: 'Ok',
      },
      nameAlert: {
        title: 'Routenname',
        contentHtml: 'Bitte geben Sie einen Routennamen ein',
        ok: 'Ok'
      },

      confirm: {
        title: 'Route bearbeiten',
        contentHtml: 'Willst Du die Änderungen an der Route wirklich speichern?',
        ok: 'Speichern',
        cancel: 'Abbrechen'
      }
    }
  },

  computed: {
    ...mapState([
      'validUser',
      'gymWalls',
      'urlGym',
      'gymClimbo',
      'newRouteLink',
      'slideRange',
      'routeColors',
      'sectorColors',
      'defaultSector',
      'gymListDetails',
      'sectorDetails',
      'totalGymRoutes'
    ]),

    xCoord () {
      return Math.round(this.marker.lat)
    },

    yCoord () {
      return Math.round(this.marker.lng)
    },

    sortColor (list) {
      return list.sort()
    }

  },

  methods: {
    ...mapMutations([
      'increment',
      'decrement',
      'changeSlideRange',
      'changeTotalGymRoutes'
    ]),

    goBack () {
      this.$router.go(-1)
    },

    restorePosition () {
      this.$refs.leafAdd.mapObject.setView([220, 350], 0)
      if (!this.isLocated) {
        this.marker = L.latLng(110, 175)
        this.draggable = true
      } else {
        this.draggable = false
        this.coordOverview = {'x': (this.xCoord), 'y': this.yCoord}
      }
    },

    condition () {
      if (this.marker.lng  < 10 || this.marker.lng > 350 ){
        this.marker = L.latLng(110, 175)
      } else if (this.marker.lat < 10 || this.marker.lat > 220){
        this.marker = L.latLng(110, 175)
      } else {
        // console.log('moving marker', this.marker)
      }
    },

    verifyLocation() {
      if (!this.isLocated) {
        this.openDialog('dialog7')
      } else {
        this.verifyName()
      }
    },

    verifyName() {
      if (!this.checkRoute()){
        this.openDialog('dialog8')
      } else if (this.checkRoute() && this.isLocated){
        this.openDialog('dialog6')
      }
    },

    setColor (item) {
      this.newLog.color = item
      this.closeDialog('color2')
    },

    setWand (wall) {
      this.newLog.wallArea = wall
      this.closeDialog('wall2')
    },

    setFrench () {
      this.newLog.grade = this.$options.filters.gradeFilter(this.slideRange)
      this.newLog.gradeFrench = this.$options.filters.frenchFilter(this.newLog.grade)
    },

    sreset () {
      this.resetting = true
      setTimeout(() => {
        this.resetting = false
        this.isLocated = false
      },100)
    },

    openDialog (ref) {
      this.$refs[ref].open()
    },

    closeDialog (ref) {
      this.$refs[ref].close()
    },
    onOpen () {
      // console.log('Opened')
    },

    onClose (type) {
      if (type === 'ok' && this.checkRoute()) {
        this.addNewroute()
        this.$router.push('/Gymlist')
      }
      // else {
      //   this.openDialog('dialog6')
      // }
      // console.log('Closed', type)
    },

    clearRoute () {
      // this.$router.go(-1).catch(err => {})
      this.removeDate = ''
      this.logDate = new Date()
      this.marker = L.latLng(110, 175)
      this.newLog = {
        routeName: '',
        grade: '',
        gradeNo: 0,
        color: '',
        wallArea: '',
        isLead: '',
        isToprope: '',
        userRating: 0,
        climbed: true,
        style: '',
        attributes: [],
        isPublished: false,
        sortWeight: -1,
        dateCreated: new Date(),
        remarks: ''
      }
      this.coordOverview = {'x': this.xCoord, 'y': this.yCoord}
      this.optionAttributes = []
      this.isLocated = false
      this.draggable = true
      this.$refs.leafAdd.mapObject.setView([220, 350], 0)
      this.sreset()
    },

    checkRoute () {
      if (!this.newLog.routeName) {
        this.errorClass = 'md-input-invalid'
        return false
      } else {
        this.errorClass = ''
        return true
      }
    },

    addNewroute() {
        this.newLog.gradeNo = (this.slideRange / 3).toFixed(1)
        this.newLog.grade = this.$options.filters.gradeFilter(this.slideRange)
        this.newLog.dateCreated = new Date(this.logDate).getTime()
        this.newLog.attributes = this.optionAttributes

        var nx = this.coordOverview.x
        var ny = this.coordOverview.y
        this.newLog.overview = {'x': nx, 'y': ny}

        // console.log('gymDetails',this.gymListDetails)
        if (this.gymListDetails.length == 0) {
          this.newLog.sortWeight = 10
        } else {
          this.newLog.sortWeight = this.gymListDetails[0].sortWeight - 10
        }
        // this.newLog.overview = this.coordOverview
        // console.log('newLog', this.newLog)
        var newRoute = JSON.stringify(this.newLog)
        // console.log('newRoute', newRoute)
        this.$http.post(this.newRouteLink, newRoute).then(response => {
          // success callback
          this.$store.dispatch('refreshGymList', this.defaultSector)
          this.clearRoute()
        }, response => {
          // error callback
        })

    }
  }
}

</script>

<style scope>

  #gymadd .md-list.md-triple-line .md-list-item .md-list-item-container {
    min-height:40px !important;
  }

  input {
    color:grey;
    font-size:16px;
    font-family:'roboto';
  }

  #gymadd img {
    max-width:none;
  }

  .wall {
    margin-left:0px !important;
  }

</style>
